import { SideNav } from '@shinetools/lumen-react'
import { type ReactElement, useCallback } from 'react'

import type { InvoicingSettingsSection } from '../../../../../../enums/invoicingSettingsSection'

interface InvoicingSettingsModalNavigationItemProps {
  isSelected: boolean
  label: string
  onSelect: (section: InvoicingSettingsSection) => void
  section: InvoicingSettingsSection
}

export const InvoicingSettingsModalNavigationItem = ({
  isSelected,
  label,
  onSelect,
  section,
}: InvoicingSettingsModalNavigationItemProps): ReactElement => {
  const handleItemClick = useCallback(() => {
    onSelect(section)
  }, [onSelect, section])

  return <SideNav.Item label={label} onClick={handleItemClick} selected={isSelected} />
}
